<template>
  <ModalTriage v-if="protocolUpdate && protocolUpdate.report_id" :visibleModalTriage="isModalTriageVisible" :protocolUpdatePopup="protocolUpdate" :enableButton="false"
               @hideModalTriage="hideModalTriage"></ModalTriage>
  <ModalReturnCase :visibleModalReturnCase="isModalReturnCaseVisible"
                   @hideModalReturnCase="hideModalReturnCase"></ModalReturnCase>
  <ModalTools :visibleModalTools="isModalToolsVisible"
                   @hideModalTools="hideModalTools" :Report="Report"></ModalTools>
  <ModalRenewSignature :visibleModalRenewSignature="isModalRenewSignatureVisible"
                       @hideModalRenewSignature="hideModalRenewSignature" @reloadPage="reloadPage"
                       ref="modalRenewSignature">
  </ModalRenewSignature>
  <div class="container">
    <div class="my-1">
      <div class="col-12">
        <div v-if="Report">
          <nav class="col-lg-8 offset-lg-2 sticky">
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <button class="flex-sm text-sm-start nav-link fs-4" @click="backProtocols()" title="Voltar">
                <i class="bi bi-arrow-left-circle-fill"></i>
              </button>
              <button class="flex-sm-fill text-sm-center nav-link active" id="nav-chat-tab" data-bs-toggle="tab"
                      data-bs-target="#nav-chat"
                      type="button" role="tab" aria-controls="nav-chat" aria-selected="true">Chat <span
                  class="badge text-bg-danger" v-if="unreadMessages">{{ unreadMessages }}</span>
              </button>
              <button class="flex-sm-fill text-sm-center nav-link" id="nav-form-tab" data-bs-toggle="tab"
                      data-bs-target="#nav-form" type="button"
                      role="tab" aria-controls="nav-form" aria-selected="false">Formulário
              </button>
              <button class="flex-sm text-sm-end nav-link fs-4" @click="showModalTriage(Report.protocol_update_info)"
                      data-bs-toggle="modal" data-bs-target="#triageModal" title="Triagem">
                <i class="bi bi-list-task"></i>
              </button>
              <button class="flex-sm text-sm-end nav-link fs-4" @click="showModalTools()"
                      data-bs-toggle="modal" data-bs-target="#toolsModal" title="Ferramentas">
                <i class="bi bi-gear"></i>
              </button>
              <button class="flex-sm text-sm-end nav-link fs-4" @click="showModalReturnCase()"
                      data-bs-toggle="modal" data-bs-target="#returnCaseModal" title="Devolver caso para fila">
                  <i class="bi bi-arrow-return-left"></i>
              </button>
              <button class="flex-sm text-sm-end nav-link text-success fs-4" @click="openReview()" title="Concluir atendimento">
                <i class="bi bi-check-circle-fill"></i>
              </button>
            </div>
          </nav>
          <div class="tab-content col-lg-8 offset-lg-2" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-chat" role="tabpanel" aria-labelledby="nav-chat-tab"
                 tabindex="0">
              <ChatComponent :ProtocolUpdate="this.Report.protocol_update_info"
                             :User="this.User.specialist" @incrementUnreadMessages="incrementUnreadMessages" @handleChatVisibility="handleChatVisibility"></ChatComponent>
            </div>
            <div class="tab-pane fade" id="nav-form" role="tabpanel" aria-labelledby="nav-form-tab" tabindex="0">
              <div v-if="isLoading">
                <div class="container my-5">
                  <div class="row mt-5">
                    <div class="row mt-4">
                      <div class="offset-2 col-8">
                        <div class="centered-container">
                          <div class="loading"></div>
                        </div>
                        <p class="text-font-regular" style="margin-top: 10px; text-align: center">
                          Carregando...
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>

                <form>
                  <div>
                    <dynamic-report :reportFields="this.reportFields" :reportInfo="this.Report" @reportFields="updateReportFields"></dynamic-report>
                  </div>
                </form>
                <div class="my-4">
                  <p class="fw-bold text-center text-black-50">Último Salvamento:
                    {{ Report.updated_at }}
                    <span v-if="loadingButtonSave">
                  <a class="btn btn-primary fw-bold ms-3" @click="saveData()">
                    <i class="bi bi-floppy"></i>
                    Salvar
                  </a>
                </span>
                    <span v-else>
                  <button class="custom-button-save fw-bold">Carregando...</button>
                </span>
                  </p>
                </div>
                <div class="text-center my-4">
                  <button class="btn btn-success fw-bold" @click="openReview()">
                    <i class="bi bi-check-circle-fill"></i>
                    Concluir atendimento
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalTriage from "../components/ModalTriage.vue";
import ModalReturnCase from "../components/ModalReturnCase.vue";
import DynamicReport from "../components/DynamicReport.vue";
import {mapGetters, mapActions} from "vuex";
import ChatComponent from "../components/ChatComponent.vue";
import ModalRenewSignature from "@/components/ModalRenewSignature.vue";
import ModalTools from "@/components/ModalTools.vue";

export default {
  name: `AttendanceForm`,
  props: ['protocol'],
  components: {
    ModalRenewSignature,
    ChatComponent: ChatComponent,
    DynamicReport,
    ModalTriage: ModalTriage,
    ModalReturnCase,
    ModalTools
  },
  computed: {
    ...mapGetters({
      User: "StateUser",
      Report: "StateReport",
      ReportFields: "StateReportFields"
    }),
  },
  beforeUnmount() {
    this.SetActiveConversationId(null);
  },
  async mounted() {
    try {
      if (this.Report !== null) {
        await this.SetActiveConversationId(this.Report.protocol_update_id);
        this.showModalTriage(this.Report.protocol_update_info);
        await this.GetReport(this.Report);
        await this.GetReportFields(this.Report.protocol_update_info.protocol_info.specialty_id);
        this.reportFields = JSON.parse(JSON.stringify(this.ReportFields));
        this.patient = this.Report != null ? this.Report.protocol_update_info !== undefined && this.Report.protocol_update_info !== null ? this.Report.protocol_update_info.protocol_info.patient_info.name : '' : '';
        this.applicant = this.Report != null ? this.Report.protocol_update_info !== undefined && this.Report.protocol_update_info !== null ? this.Report.protocol_update_info.responsible_info.name : '' : '';

        for (const field in this.fieldMappings) {
          const reportField = this.fieldMappings[field];
          const value = this.Report != null ? this.Report[reportField] !== undefined && this.Report[reportField] !== null ? this.Report[reportField] : null : null
          this.setFieldValue(field, value);
        }
        //Específico:
        this.setFieldValue("video_realized", this.Report != null ? this.Report.video_findings !== undefined && this.Report.video_findings !== null ? 1 : 0 : 0);
        this.applyRules();
        this.isLoading = false;
      }
    } catch (err) {
      console.log(err)
      this.$toast.error('Ocorreu um erro, tente novamente.', {
        timeout: 3000,
        closeOnClick: true
      });
    }
  },
  data() {
    return {
      loadingButton: true,
      loadingButtonSave: true,
      isModalRenewSignatureVisible: false,
      isChatVisible: false,
      fieldMappings: {
        "clinical_history": "clinical_history",
        "specialist_findings": "specialist_findings",
        "diagnostic_hypothesis": "diagnostic_hypothesis_id",
        "diagnostic_hypothesis_another": "diagnostic_hypothesis_another",
        "diagnostic_complement": "diagnostic_complement",
        "sedated": "sedated",
        "glasgow": "glasgow",
        "transference": "transference",
        "outcome": "outcome_type_id",
        "conduct": "conduct",
        "specialized_prescription": "specialized_prescription",
        "video_findings": "video_findings",
        "daily_goal": "daily_goal",
        "daily_evolution": "daily_evolution",
        "glycated_hemoglobin": "glycated_hemoglobin",
        "leukogram": "leukogram",
        "platelet_count": "platelet_count",
        "crp": "crp",
        "urea": "urea",
        "creatinine": "creatinine",
        "blood_gas_analysis": "blood_gas_analysis",
        "sodium": "sodium",
        "potassium": "potassium",
        "others": "others",
        "cid_subcategory": "cid_subcategory_id",
        "protocol_avc": "protocol_avc",
        "thrombolysis": "thrombolysis",
        "catheterization": "catheterization",
        "clinical_documents": "clinical_documents",
        "had_teleconsultation": "had_teleconsultation",
        "patient_present": "patient_present"
      },
      reportFields: [],
      isLoading: true,
      isModalTriageVisible: false,
      isModalReturnCaseVisible: false,
      isModalToolsVisible: false,
      protocolUpdate: null,
      patient: null,
      applicant: null,
      unreadMessages: 0
    };
  },
  async created() {
    if (!this.isAuthenticated()) {
      this.$router.push("/login");
    }
    if (this.Report === null) {
      this.$router.push("/");
    }
  },
  methods: {
    ...mapActions(["GetReportFields"]),
    ...mapActions(["GetEnable"]),
    ...mapActions(["GetReport"]),
    ...mapActions(["SetReport"]),
    ...mapActions(["UpdateReport"]),
    ...mapGetters(["isAuthenticated"]),
    ...mapActions(['openModalSignatureRequired']),
    ...mapActions(["SetActiveConversationId"]),

    updateReportFields(newFields) {
      this.reportFields = newFields;
    },

    handleChatVisibility(isVisible){
      this.isChatVisible = isVisible;
      if(isVisible){
        this.unreadMessages = 0;
      }
    },
    incrementUnreadMessages(){
      if(!this.isChatVisible)
        this.unreadMessages++;
    },
    async saveData() {
      this.loadingButtonSave = false
      try {
        await this.checkInputChange()
        await this.GetReport(this.Report);
        this.loadingButtonSave = true;
      } catch {
        this.$toast.error('Ocorreu um erro, tente novamente.', {
          timeout: 3000,
          closeOnClick: true
        });
        this.loadingButtonSave = true;
      }
    },
    applyRules() {
      const filteredArray = this.reportFields.filter((item) => {
        return item.rules.length > 0;
      });
      filteredArray.forEach((field) => {
        field.rules.forEach((rule) => {
          const targetField = this.reportFields.find(
              (item) => item.name === rule.parameters[2]
          );
          if (targetField && rule.parameters[0] === "field_equals") {
            if (rule.name === "reveals_to") {
              targetField.visible = rule.parameters[1] === this.recoverFieldValue(field.name);
            } else if (rule.name === "forces_to") {
              targetField.required = rule.parameters[1] === this.recoverFieldValue(field.name);
            }
          }
        });
      });
    },
    async checkInputChange() {
      const info = {};
      for (const field in this.fieldMappings) {
        const reportField = this.fieldMappings[field];
        const recoverFieldValue = this.recoverFieldValue(field) !== undefined && this.recoverFieldValue(field) !== null ? this.recoverFieldValue(field) : null;
        const reportValue = this.Report != null ? (this.Report[reportField] !== undefined && this.Report[reportField] !== null ? this.Report[reportField] : null) : null;
        if (recoverFieldValue !== reportValue) {
          info[reportField] = recoverFieldValue;
        }
      }
      const reportUpdate = {
        id: this.Report.id,
        info: info
      }
      if (Object.keys(reportUpdate.info).length > 0) {
        await this.UpdateReport(reportUpdate);
        this.$toast.success('Dados salvos com sucesso', {
          timeout: 3000,
          closeOnClick: true
        });
      } else {
        this.$toast.warning('Dados sem alterações, não foi necessário salvar', {
          timeout: 3000,
          closeOnClick: true
        });
      }
    },
    async saveChanges() {      
      const info = {};
      for (const field in this.fieldMappings) {
        const reportField = this.fieldMappings[field];
        info[reportField] = this.recoverFieldValue(field);
      }
      const reportUpdate = {
        id: this.Report.id,
        info: info
      }
      await this.UpdateReport(reportUpdate);
    },
    recoverFieldValue(fieldName) {
      const filteredArray = this.reportFields.filter((item) => {
        return item.name === fieldName;
      });
      if (filteredArray.length > 0) {
        return filteredArray[0].value;
      }
    },
    setFieldValue(fieldName, valueField) {
      const filteredArray = this.reportFields.filter((item) => {
        return item.name === fieldName;
      });
      if (filteredArray.length > 0) {
        return filteredArray[0].value = valueField;
      }
    },
    showModalTriage(protocolUpdate) {
      this.protocolUpdate = protocolUpdate;
      this.isModalTriageVisible = true;
    },
    hideModalTriage() {
      this.protocolUpdate = null;
      this.isModalTriageVisible = false;
    },
    showModalReturnCase() {
      this.isModalReturnCaseVisible = true;
    },
    hideModalReturnCase() {
      this.isModalReturnCaseVisible = false;
    },
    showModalTools() {
      this.isModalToolsVisible = true;
    },
    hideModalTools() {
      this.isModalToolsVisible = false;
    },
    async backProtocols() {
      try {
        await this.saveChanges();
        this.$router.push('/protocols');
      } catch {
        this.$toast.error('Ocorreu um erro, tente novamente.', {
          timeout: 3000,
          closeOnClick: true
        });
      }
    },

    validFields() {
      const fields = [];
      this.reportFields.forEach(item => {
        if (item.required && (item.value === '' || item.value === null || item.value === undefined)) {
          fields.push(item.description.replace(/[:?]/g, ''));
        }
      });
      return fields;
    },
    async openReview() {
      try {
        this.isLoading = true;
        this.loadingButton = false;
        await this.GetEnable();
        const dateActual = new Date();
        const resultValidacao = this.validFields();
        if (this.User.user_cess_access_info != null) {
          const dateExpired = new Date(this.User.user_cess_access_info.expired_at);
          if (dateActual > dateExpired) {
            this.$refs.modalRenewSignature.show();
          } else {
            await this.handleValidFields(resultValidacao);
          }
        } else {
          await this.handleValidFields(resultValidacao);
        }
      } catch (error) {
        this.handleError();
        this.isLoading = false;

      } finally {
        this.loadingButton = true;
        this.isLoading = false;
      }
    },
    async handleValidFields(resultValidacao) {
      if (resultValidacao.length === 0) {
        try {
          this.isLoading = true;
          await this.saveChanges();
          await this.SetReport(this.Report);
          this.isLoading = false;
          this.$router.push({name: 'Review'});
        } catch (error) {
          this.handleError();
        }
      } else {
        this.showValidationError(resultValidacao);
      }
    },
    showValidationError(resultValidacao) {
      this.$toast.error('Existem campos não preenchidos:\n' + resultValidacao.join('\n'), {
        timeout: 3000,
        closeOnClick: true
      });
    },
    handleError() {
      this.$toast.error('Ocorreu um erro, tente novamente.', {
        timeout: 3000,
        closeOnClick: true
      });
    },
    hideModalRenewSignature() {
      this.isModalRenewSignatureVisible = false;
    },

  }
}
;
</script>

<style>
.custom-button-save {
  background: none;
  border: none;
  color: #6200ee;
  cursor: pointer;
  font-size: 16px;
  margin-left: 15px;
}

.loading {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.centered-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.sticky {
  position: sticky;
  top:0;
  z-index: 999;
  background:#fff
}
</style>
